/** 屏幕底部的圆形总进度指示器，读取 FlyingCamera 暴露的全局滚动比例。 */
import { useEffect, useRef } from 'react';
import round from 'lodash.round';
import MouseSVG from '../../../svg/mouse';

// 半径 50 的圆周约为 2πr = 314；该值来自实际 SVG 路径测量。
const length = round(313.6517333984375, 3);

const ProgressRound = () => {
    const circle = useRef<SVGCircleElement>(null);

    useEffect(() => {
        let rAF = 0;

        const fn = () => {
            // dashoffset 从整圈长度逐渐减到 0，视觉上表现为圆环被慢慢画满。
            circle.current?.setAttribute(
                'stroke-dashoffset',
                `${round(
                    length * (1 - (window as any)._scrollOffset || 0),
                    3,
                )}`,
            );
            // 不触发 React state 更新，直接改 SVG 属性以降低每帧开销。
            rAF = requestAnimationFrame(fn);
        };

        fn();

        return () => {
            cancelAnimationFrame(rAF);
        };
    }, []);

    return (
        <div className="progress-round">
            <svg
                width="100"
                height="100"
                viewBox="0 0 100 100"
                className="progress-round__el"
            >
                <circle
                    ref={circle}
                    r="50"
                    cx="50"
                    cy="50"
                    fill="none"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeDasharray={`${length} ${length}`}
                ></circle>
            </svg>
            <span className="progress-round__icon">
                <MouseSVG />
            </span>
        </div>
    );
};

export default ProgressRound;
